<template>
  <div class="set-account">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "SetAccount"
};
</script>

<style lang='less' scoped>
.set-account {
  height: 626px;
  padding-top: 45px;
  padding-left: 54px;
  border: 1px solid #ccc;
}
</style>